import { useEffect, useState } from 'react'

import { startOfTomorrow } from 'date-fns'

export function useToday(): Date {
  const [today, setToday] = useState(() => new Date())

  useEffect(() => {
    const timer = window.setTimeout(
      () => setToday(new Date()),
      startOfTomorrow().getTime() - Date.now(),
    )
    return () => window.clearTimeout(timer)
  }, [today])

  return today
}
